import http from './http'

export default class CertifyApi{
	// 获取认证信息
	static findCertifyByUserId(data) {
		return http.httpPost('/certify/findCertifyByUserId', data)
	}
	// 个人认证
	static perCertify(data) {
		return http.httpPost('/certify/perCertify', data)
	}
	// 企业认证
	static entCertify(data) {
		return http.httpPost('/certify/entCertify', data)
	}
}
